module.exports = __webpack_public_path__ + "static/media/atendimento-2.956b78f9.png";